<template>
  <money
    class="form-control"
    v-bind:value="value"
    v-on:input="handleChange"
    v-bind="percent"
    maxlength="12"
  />
</template>

<script>
export default {
  name: "input-percent",
  props: ["value", "precision"],
  data() {
    return {
      percent: {
        decimal: ",",
        thousands: ".",
        suffix: "% ",
        precision: !!this.precision ? this.precision : 4,
        masked: false,
      },
    };
  },
  methods: {
    handleChange(event) {
      if (event instanceof Object) {
        this.$emit("input", event.target.value);
      } else {
        this.$emit("input", event);
      }
    },
  },
};
</script>
